var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat309(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_309"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_309",
    "data-name": 309,
    className: "cls-2",
    d: "M70.35,2.86C58.76-1.28,46.08,9.8,40.87,19.24c-6.8,12.31.78,19.56-6.55,32.76-4,7.16-13.21,11.84-16.18,19.82S19.14,90,25.61,95c8.69,6.66,19.7,1.63,26.87-5.17,9.21-8.73,14.74-21.56,20.79-32.56C80.58,43.93,91.88,10.53,70.35,2.86Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat309);
export default __webpack_public_path__ + "static/media/cat_309.16a02996c4605404dacc0a476aa49d17.svg";
export { ForwardRef as ReactComponent };